const API_BASE_URL = process.env.REACT_APP_API_URL;

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // GET request
  async get(endpoint) {
    return this.request(endpoint, {
      method: 'GET',
    });
  }

  // POST request
  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // PUT request
  async put(endpoint, data) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  // DELETE request
  async delete(endpoint) {
    return this.request(endpoint, {
      method: 'DELETE',
    });
  }

  // Content-specific methods
  async getHeroContent() {
    return this.get('/hero');
  }

  async getAboutContent() {
    return this.get('/about');
  }

  async getServicesContent() {
    return this.get('/services');
  }

  async getTeamContent() {
    return this.get('/team');
  }

  async getContactContent() {
    return this.get('/contact');
  }

  async getGenericContent(type) {
    return this.get(`/content/generic/${type}`);
  }

  // Admin authentication
  async login(credentials) {
    return this.post('/auth/login', credentials);
  }

  async logout() {
    return this.post('/auth/logout');
  }

  // Admin content management
  async updateHeroContent(data) {
    return this.put('/hero', data);
  }

  async deleteHeroImage() {
    return this.delete('/hero/image');
  }

  async updateAboutContent(data) {
    return this.put('/about', data);
  }

  async deleteAboutImage() {
    return this.delete('/about/image');
  }

  async updateServicesContent(data) {
    return this.put('/services', data);
  }

  // Team member methods
  async getTeamMembers() {
    return this.get('/team');
  }

  async getTeamMember(id) {
    return this.get(`/team/${id}`);
  }

  async createTeamMember(data) {
    return this.post('/team', data);
  }

  async updateTeamMember(id, data) {
    return this.put(`/team/${id}`, data);
  }

  async deleteTeamMember(id) {
    return this.delete(`/team/${id}`);
  }

  async updateTeamContent(data) {
    return this.put('/team', data);
  }

  async updateContactContent(data) {
    return this.put('/contact', data);
  }

  // News Post methods
  async getNewsPosts() {
    return this.get('/news-posts');
  }

  async getNewsPostImages(postId) {
    return this.get(`/news-posts/${postId}/images`);
  }

  async createNewsPost(data) {
    return this.post('/news-posts', data);
  }

  async updateNewsPost(id, data) {
    return this.put(`/news-posts/${id}`, data);
  }

  async deleteNewsPost(id) {
    return this.delete(`/news-posts/${id}`);
  }

  async updateGenericContent(type, data) {
    return this.put(`/content/generic/${type}`, data);
  }
}

export default new ApiService();
